import React from "react";

export default function Success() {
	return (
		<section className="section-success container">
			<h1 className="h3">
				Thank you for your interest
				<br /> in ch-aviation.
			</h1>
			<p className="h3">
				Your request has been received, and our team will contact you
				soon.
			</p>
		</section>
	);
}
